export default "__VITE_ASSET__DkjuQWOX__"